import { FIELDS, PRODUCT_TYPE_MODELS, SHARE_CLASS, RANGE_SELECTOR_MODELS } from '../../shared/screener-constants';
import _cloneDeep from 'lodash/cloneDeep';

export const AbsolutePerfTagMap = {
  5: {
    tag: 'High Performance',
    hoverText: 'Investments with highest 3-year average returns',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.PERFORMANCE,
    range: 4
  },
  4: {
    tag: 'Above Average Performance',
    hoverText: 'Investments with higher 3-year average returns',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.PERFORMANCE,
    range: 3
  }
  //  Commenting out these tags at TIAA's request - see TIAA-11004
  //  3: { tag: 'Average Performance', hoverText: 'Investments with moderate 3-year average returns' },
  //  2: { tag: 'Below Average Performance', hoverText: 'Investments with lower 3-year average returns' },
  //  1: { tag: 'Low Performance', hoverText: 'Investments with lowest 3-year average returns' }
};

export const perfVsPeerTagMap = {
  5: {
    tag: 'High Performance vs Peers',
    hoverText: 'Investments with highest 3-year average returns in their category',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.PERF_VS_PEERS,
    range: 4
  }
};

export const absoluteRiskTagMap = {
  5: {
    tag: 'High Risk',
    hoverText: 'Most volatile investments with greatest potential returns',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.RISK,
    range: 4
  },
  4: {
    tag: 'Above Average Risk',
    hoverText: 'More volatile investments with greater potential returns',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.RISK,
    range: 3
  },
  3: {
    tag: 'Average Risk',
    hoverText: 'Moderately volatile investments with average potential returns',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.RISK,
    range: 2
  },
  2: {
    tag: 'Below Average Risk',
    hoverText: 'Less volatile investments with lower potential returns',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.RISK,
    range: 1
  },
  1: {
    tag: 'Low Risk',
    hoverText: 'Least volatile investments with lowest potential returns',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.RISK,
    range: 0
  }
};

export const riskVsPeerTagMap = {
  1: {
    tag: 'Low Risk vs Peers',
    hoverText: 'Investments with lowest risk in their category',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.RISK_VS_PEERS,
    range: 0
  }
};

export const yieldTagMap = {
  5: {
    tag: 'High Yield',
    hoverText: 'Investments which generate the highest amount of income',
    filter: 'rangeFilters',
    modelKey: RANGE_SELECTOR_MODELS.YIELD,
    range: 4
  }
};

export const ratingTagMap = {
  //Both 4 and 5 are required for 4 and 5 star rated funds
  5: { tag: 'High Ratings vs Peers', hoverText: 'Investments rated four or five stars by Morningstar™', filter: 'ratingsFilter' },
  4: { tag: 'High Ratings vs Peers', hoverText: 'Investments rated four or five stars by Morningstar™', filter: 'ratingsFilter' }
};

export const MStarBondDurationTagMap = {
  9: { tag: 'Long Duration', hoverText: 'Relatively high exposure to interest rate changes' },
  8: { tag: 'Medium Duration', hoverText: 'Moderate exposure to interest rate changes' },
  7: { tag: 'Short Duration', hoverText: 'Relatively low exposure to interest rate changes' },
  6: { tag: 'Long Duration', hoverText: 'Relatively high exposure to interest rate changes' },
  5: { tag: 'Medium Duration', hoverText: 'Moderate exposure to interest rate changes' },
  4: { tag: 'Short Duration', hoverText: 'Relatively low exposure to interest rate changes' },
  3: { tag: 'Long Duration', hoverText: 'Relatively high exposure to interest rate changes' },
  2: { tag: 'Medium Duration', hoverText: 'Moderate exposure to interest rate changes' },
  1: { tag: 'Short Duration', hoverText: 'Relatively low exposure to interest rate changes' }
};

export const MStarBondQualityTagMap = {
  9: { tag: 'Low Credit Quality', hoverText: 'Average credit rating is high yield' },
  8: { tag: 'Low Credit Quality', hoverText: 'Average credit rating is high yield' },
  7: { tag: 'Low Credit Quality', hoverText: 'Average credit rating is high yield' },
  6: { tag: 'Moderate Credit Quality', hoverText: 'Average credit rating is above high yield, but not highest quality' },
  5: { tag: 'Moderate Credit Quality', hoverText: 'Average credit rating is above high yield, but not highest quality' },
  4: { tag: 'Moderate Credit Quality', hoverText: 'Average credit rating is above high yield, but not highest quality' },
  3: { tag: 'High Credit Quality', hoverText: 'Average credit risk is very low' },
  2: { tag: 'High Credit Quality', hoverText: 'Average credit risk is very low' },
  1: { tag: 'High Credit Quality', hoverText: 'Average credit risk is very low' }
};

export const MStarEquityValueTagMap = {
  9: { tag: 'Growth', hoverText: 'Investments with companies expected to grow sales & earnings relatively fast' },
  8: { tag: 'Blend', hoverText: 'Investments with both value and growth stocks' },
  7: { tag: 'Value', hoverText: 'Investments with stocks that have low prices relative to fundamentals' },
  6: { tag: 'Growth', hoverText: 'Investments with companies expected to grow sales & earnings relatively fast' },
  5: { tag: 'Blend', hoverText: 'Investments with both value and growth stocks' },
  4: { tag: 'Value', hoverText: 'Investments with stocks that have low prices relative to fundamentals' },
  3: { tag: 'Growth', hoverText: 'Investments with companies expected to grow sales & earnings relatively fast' },
  2: { tag: 'Blend', hoverText: 'Investments with both value and growth stocks' },
  1: { tag: 'Value', hoverText: 'Investments with stocks that have low prices relative to fundamentals' }
};

export const MStarEquitySizeTagMap = {
  9: { tag: 'Small', hoverText: 'Average company size is small, higher potential growth/risk' },
  8: { tag: 'Small', hoverText: 'Average company size is small, higher potential growth/risk' },
  7: { tag: 'Small', hoverText: 'Average company size is small, higher potential growth/risk' },
  6: { tag: 'Mid', hoverText: 'Average company size is in the middle of the range' },
  5: { tag: 'Mid', hoverText: 'Average company size is in the middle of the range' },
  4: { tag: 'Mid', hoverText: 'Average company size is in the middle of the range' },
  3: { tag: 'Large', hoverText: 'Average company size is relatively large' },
  2: { tag: 'Large', hoverText: 'Average company size is relatively large' },
  1: { tag: 'Large', hoverText: 'Average company size is relatively large' }
};

export const ProductTypeTagMap = {
  'Custom Portfolio Models': {
    tag: 'RetirePlus Pro Models',
    hoverText: 'Professionally managed investment portfolios unique to your institution',
    filter: 'productTypeFilters',
    filterValue: PRODUCT_TYPE_MODELS.RETIREPROPLUSMODELS
  },
  'FDIC Insured Products': {
    tag: 'FDIC Insured Products',
    hoverText: 'Bank-related products insured by the federal government',
    filter: 'productTypeFilters',
    filterValue: PRODUCT_TYPE_MODELS.FDICINSUREDPRODUCTS
  },
  'Fixed Annuities': {
    tag: 'Fixed Annuities',
    hoverText: 'Guaranteed daily growth without the risk of losing money',
    filter: 'productTypeFilters',
    filterValue: PRODUCT_TYPE_MODELS.FIXEDANNUITIES
  },
  'Mutual Funds': {
    tag: 'Mutual Funds',
    hoverText: "Professionally invested to match the fund's objective",
    filter: 'productTypeFilters',
    filterValue: PRODUCT_TYPE_MODELS.MUTUALFUNDS,
    classSelection: SHARE_CLASS.ALL
  },
  'RetirePlus Models': {
    tag: 'RetirePlus Select Models',
    hoverText: 'Professionally managed investment portfolios unique to your institution',
    filter: 'productTypeFilters',
    filterValue: PRODUCT_TYPE_MODELS.RETIREPLUSMODELS
  },
  'Variable Annuities': {
    tag: 'Variable Annuities',
    hoverText: 'Designed to provide long-term performance and growth potential',
    filter: 'productTypeFilters',
    filterValue: PRODUCT_TYPE_MODELS.VARIABLEANNUITIES
  }
};

export const AssetClassTagMap = {
  Equities: {
    tag: 'Equity',
    hoverText: 'Investments mostly comprised of stocks',
    filter: 'assetClassFilters',
    modelKey: 'equities'
  },
  'Fixed Income': {
    tag: 'Fixed Income',
    hoverText: 'Investments mostly comprised of corporate or government bonds',
    filter: 'assetClassFilters',
    modelKey: 'fixedIncome'
  },
  Guaranteed: {
    tag: 'Guaranteed',
    hoverText: 'Annuities that provide a guaranteed fixed return',
    filter: 'assetClassFilters',
    modelKey: 'guaranteed'
  },
  'Money Market': {
    tag: 'Money Market',
    hoverText: 'Short-term investments including government-issued securities & CDs',
    filter: 'assetClassFilters',
    modelKey: 'moneyMarket'
  },
  'Multi-Asset': {
    tag: 'Multi Asset',
    hoverText: '	Investments comprised of both equities and fixed income',
    filter: 'assetClassFilters',
    modelKey: 'multiAsset'
  },
  'Real Estate': {
    tag: 'Real Estate',
    hoverText: 'Investments with direct exposure to commercial properties',
    filter: 'assetClassFilters',
    modelKey: 'realEstate'
  }
};

export const StyleBoxesBondsTagMap = {

  'Long Duration': {
    tag: 'Long Duration',
    filter: 'styleBoxesBonds',
    modelKey: 'longduration'
  },
  'Medium Duration': {
    tag: 'Medium Duration',
    filter: 'styleBoxesBonds',
    modelKey: 'mediumduration'
  },
  'Short Duration': {
    tag: 'Short Duration',
    filter: 'styleBoxesBonds',
    modelKey: 'shortduration'
  },
  'Low Credit Quality': {
    tag: 'Low Credit Quality',
    filter: 'styleBoxesBonds',
    modelKey: 'lowcreditquality'
  },
  'Moderate Credit Quality': {
    tag: 'Moderate Credit Quality',
    filter: 'styleBoxesBonds',
    modelKey: 'moderatecreditquality'
  },
  'High Credit Quality': {
    tag: 'High Credit Quality',
    filter: 'styleBoxesBonds',
    modelKey: 'highcreditquality'
  }
}

export const StyleBoxesEquitiesTagMap = {

  'Growth': {
    tag: 'Growth',
    filter: 'styleBoxesEquities',
    modelKey: 'equitygrowth'
  },
  'Blend': {
    tag: 'Blend',
    filter: 'styleBoxesEquities',
    modelKey: 'equityblend'
  },
  'Value': {
    tag: 'Value',
    filter: 'styleBoxesEquities',
    modelKey: 'equityvalue'
  },
  'Small': {
    tag: 'Small',
    filter: 'styleBoxesEquities',
    modelKey: 'equitysmall'
  },
  'Mid': {
    tag: 'Mid',
    filter: 'styleBoxesEquities',
    modelKey: 'equitymid'
  },
  'Large': {
    tag: 'Large',
    filter: 'styleBoxesEquities',
    modelKey: 'equitylarge'
  }
}

export const ExpenseTagMap = {
  1: {
    tag: 'Low Expense',
    hoverText: 'Less expensive investments with fewer operating and management fees',
    filter: 'expenseFilters',
    modelKey: 'expenseModel',
    range: 0
  }
};

export const queryStringMap = {
  //AbsolutePerf
  highperformance: AbsolutePerfTagMap[5],
  aboveaverageperformance: AbsolutePerfTagMap[4],

  //perfVsPeer
  highperformancevspeers: perfVsPeerTagMap[5],

  //absoluteRisk
  highrisk: absoluteRiskTagMap[5],
  aboveaveragerisk: absoluteRiskTagMap[4],
  averagerisk: absoluteRiskTagMap[3],
  belowaveragerisk: absoluteRiskTagMap[2],
  lowrisk: absoluteRiskTagMap[1],

  //riskVsPeer
  lowriskvspeers: riskVsPeerTagMap[1],

  //Yield
  highyield: yieldTagMap[5],

  //Rating
  highratingsvspeers: ratingTagMap[4],

  //MStarBondDuration
  longduration: StyleBoxesBondsTagMap['Long Duration'],
  mediumduration: StyleBoxesBondsTagMap['Medium Duration'],
  shortduration: StyleBoxesBondsTagMap['Short Duration'],

  //MStarBondQuality
  lowcreditquality: StyleBoxesBondsTagMap['Low Credit Quality'],
  moderatecreditquality: StyleBoxesBondsTagMap['Moderate Credit Quality'],
  highcreditquality: StyleBoxesBondsTagMap['High Credit Quality'],

  //MStarEquityValue
  growth: StyleBoxesEquitiesTagMap['Growth'],
  blend: StyleBoxesEquitiesTagMap['Blend'],
  value: StyleBoxesEquitiesTagMap['Value'],

  //MStarEquitySize
  small: StyleBoxesEquitiesTagMap['Small'],
  mid: StyleBoxesEquitiesTagMap['Mid'],
  large: StyleBoxesEquitiesTagMap['Large'],

  //Product Types
  retirepluspromodels: ProductTypeTagMap['Custom Portfolio Models'],
  fdicinsuredproducts: ProductTypeTagMap['FDIC Insured Products'],
  fixedannuities: ProductTypeTagMap['Fixed Annuities'],
  mutualfunds: ProductTypeTagMap['Mutual Funds'],
  retireplusselectmodels: ProductTypeTagMap['RetirePlus Models'],
  variableannuities: ProductTypeTagMap['Variable Annuities'],

  //AssetClass
  equity: AssetClassTagMap['Equities'],
  fixedincome: AssetClassTagMap['Fixed Income'],
  guaranteed: AssetClassTagMap['Guaranteed'],
  moneymarket: AssetClassTagMap['Money Market'],
  multiasset: AssetClassTagMap['Multi-Asset'],
  realestate: AssetClassTagMap['Real Estate'],

  //expense
  lowexpense: ExpenseTagMap[1]
};

const addAllTags = data => {
  data = _cloneDeep(data);
  data.forEach(row => {
    // collapseTagsArray is used to display the 4 default tags
    // tagsArray contains all the tag
    const tagsArray = [];
    const collapseTagsArray = [];

    const perfTag = AbsolutePerfTagMap[row[FIELDS.PERFORMANCEFILTER]];
    if (row.hasOwnProperty(FIELDS.PERFORMANCEFILTER) && perfTag) {
      tagsArray.push(perfTag);
      collapseTagsArray.push(perfTag);
    }

    const riskTag = absoluteRiskTagMap[row[FIELDS.RISKFILTER]];
    if (row.hasOwnProperty(FIELDS.RISKFILTER) && riskTag) {
      tagsArray.push(riskTag);
      collapseTagsArray.push(riskTag);
    }

    const ratingTag = ratingTagMap[row[FIELDS.MSTARRATINGOVERALL]];
    if (row.hasOwnProperty(FIELDS.MSTARRATINGOVERALL) && ratingTag) {
      tagsArray.push(ratingTag);
      collapseTagsArray.push(ratingTag);
    }

    const expenseTag = ExpenseTagMap[row[FIELDS.TCNETEXPENSESFILTERPTILETANK]];
    if (row.hasOwnProperty(FIELDS.TCNETEXPENSESFILTERPTILETANK) && expenseTag) {
      tagsArray.push(expenseTag);
      collapseTagsArray.push(expenseTag);
    }

    const perfVPeerTag = perfVsPeerTagMap[row[FIELDS.PERFVSPEERSFILTER]];
    if (row.hasOwnProperty(FIELDS.PERFVSPEERSFILTER) && perfVPeerTag) {
      tagsArray.push(perfVPeerTag);
    }

    const riskVPeerTag = riskVsPeerTagMap[row[FIELDS.RISKVSPEERS]];
    if (row.hasOwnProperty(FIELDS.RISKVSPEERS) && riskVPeerTag) {
      tagsArray.push(riskVPeerTag);
    }

    const yieldTag = yieldTagMap[row[FIELDS.YIELDFILTER]];
    if (row.hasOwnProperty(FIELDS.YIELDFILTER) && yieldTag && row[FIELDS.ASSETCLASS]?.toLowerCase() !== 'guaranteed') {
      tagsArray.push(yieldTag);
    }

    const equityValueTag = MStarEquityValueTagMap[row[FIELDS.MSTAREQUITYBOXFILTER]];
    if (row.hasOwnProperty(FIELDS.MSTAREQUITYBOXFILTER) && equityValueTag) {
      tagsArray.push(equityValueTag);
    }

    const equitySizeTag = MStarEquitySizeTagMap[row[FIELDS.MSTAREQUITYBOXFILTER]];
    if (row.hasOwnProperty(FIELDS.MSTAREQUITYBOXFILTER) && equitySizeTag) {
      tagsArray.push(equitySizeTag);
    }

    const bondDurationTag = MStarBondDurationTagMap[row[FIELDS.MSTARBONDBOXFILTER]];
    if (row.hasOwnProperty(FIELDS.MSTARBONDBOXFILTER) && bondDurationTag) {
      tagsArray.push(bondDurationTag);
    }

    const bondQualityTag = MStarBondQualityTagMap[row[FIELDS.MSTARBONDBOXFILTER]];
    if (row.hasOwnProperty(FIELDS.MSTARBONDBOXFILTER) && bondQualityTag) {
      tagsArray.push(bondQualityTag);
    }

    const productTag = ProductTypeTagMap[row[FIELDS.PRODUCTTYPE]];
    if (row.hasOwnProperty(FIELDS.PRODUCTTYPE) && productTag) {
      tagsArray.push(productTag);
    }

    const assetTag = AssetClassTagMap[row[FIELDS.ASSETCLASS]];
    if (row.hasOwnProperty(FIELDS.ASSETCLASS) && assetTag) {
      tagsArray.push(assetTag);
    }

    row['tags'] = tagsArray;
    row['collapseTags'] = collapseTagsArray;
    return row;
  });

  return data;
};

export default addAllTags;

